import { Component } from '@angular/core';
import { DXFService } from '../../../services/dxf.service';

@Component({
  selector: 'ebw-dxf-map-control',
  templateUrl: './dxf-map-control.component.html',
  styleUrls: ['./dxf-map-control.component.scss']
})
export class DXFMapControlComponent {
  constructor(private _dxfService: DXFService) {}

  openDXF() {
    if (!this._dxfService.isDXFOpen()) {
      this._dxfService.openDXF();
    }
  }
}
